var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377.4,
    height: 111,
    viewBox: "0 0 377.4 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 235.8,
    height: 48.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 59.085,
    height: 71.934,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 104,
    height: 111,
    transform: "translate(40)",
    fill: "#78be20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(181.6 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M65.8,11.5a1.347,1.347,0,0,0-1.3,1.4V40.5a27.044,27.044,0,0,1-6.3.7c-4.8,0-6.5-1.8-6.5-7V12.9a1.4,1.4,0,0,0-1.2-1.4H43.1V34.3c0,10.7,5.7,14.2,14.8,14.2A59.372,59.372,0,0,0,73,46.2V11.5ZM177,48.1a1.347,1.347,0,0,0,1.3-1.4V18.8a27.3,27.3,0,0,1,6.4-.7c4.8,0,6.5,1.8,6.5,7V46.7a1.4,1.4,0,0,0,1.2,1.4h7.4V25c0-10.7-5.6-14.2-14.8-14.2a59.372,59.372,0,0,0-15.1,2.3v35ZM148,10.9c-9.4,0-15.4,5.1-15.4,16v5.5c0,12.1,6.4,16,13.4,16a12.019,12.019,0,0,0,8.1-3.9v2.3a1.324,1.324,0,0,0,1.3,1.3h7.3V13A60.661,60.661,0,0,0,148,10.9m6.1,28.3a8.2,8.2,0,0,1-6.1,2.3c-4.8,0-6.8-2.9-6.8-9.1V27.3c0-7.2,2.6-9.1,6.8-9.1a30.779,30.779,0,0,1,6.1.4Zm67-28.3c-9.4,0-15.4,5.1-15.4,16v5.5c0,12.1,6.4,16,13.4,16a12.019,12.019,0,0,0,8.1-3.9v2.3a1.4,1.4,0,0,0,1.3,1.3h7.3V13a60.661,60.661,0,0,0-14.7-2.1m6.2,28.3a8.347,8.347,0,0,1-6.1,2.3c-4.8,0-6.8-2.9-6.8-9.1V27.3c0-7.2,2.6-9.1,6.8-9.1a30.779,30.779,0,0,1,6.1.4ZM0,48.1H7.7A1.324,1.324,0,0,0,9,46.8V26.6H23.2a4.08,4.08,0,0,1,4.1,3.9V46.9a1.324,1.324,0,0,0,1.3,1.3h7.7V0H28.6a1.3,1.3,0,0,0-1.3,1.2v18H12.5A3.508,3.508,0,0,1,9,15.9V1.2A1.24,1.24,0,0,0,7.7,0H0ZM113.6,10.9a18.2,18.2,0,0,0-9.6,2.8c-2.6-2-6.2-2.8-10.6-2.8a36.625,36.625,0,0,0-13.1,2.4V48.1h7.2a1.324,1.324,0,0,0,1.3-1.3v-28a15.225,15.225,0,0,1,4.2-.6c5,0,6.2,2,6.2,7V46.8a1.493,1.493,0,0,0,1.3,1.4h6a1.324,1.324,0,0,0,1.3-1.3V19.8a8.164,8.164,0,0,1,5-1.7c3.9,0,5.4,1.7,5.4,6.5V46.7a1.493,1.493,0,0,0,1.3,1.4h7.2V23.4c0-9.3-5.8-12.5-13.1-12.5",
    fill: "#5c9a1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(62.458 23.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M42.672,0A1.948,1.948,0,0,0,40.73,1.942V27.154H24.186a5.846,5.846,0,0,1-5.829-5.828V1.942A1.948,1.948,0,0,0,16.414,0H0V71.934H16.414a1.948,1.948,0,0,0,1.942-1.942V44.1H34.9A5.847,5.847,0,0,1,40.73,49.93V69.992a1.948,1.948,0,0,0,1.942,1.942H59.085V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanaLogo);
export default __webpack_public_path__ + "static/media/Humana_logo.6de27f462030a3bb15ae92b0a11b98b8.svg";
export { ForwardRef as ReactComponent };